import React, { useEffect, useState } from 'react';
import { StepContainer } from './components/StepContainer';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { useSelector } from 'react-redux';
import { HeaderFeature } from '@app/src/common/header';

interface Args {
  step?: number;
  alias?: string;
  title?: string;
  announcementAvailable?: boolean;
}

const hoc = (Component: React.FC<{}>, args?: Args) => () => {
  const print = useSelector(state => state.print.general);
  const categoryId = print && print.category;
  const categoryIdPackage = useSelector(state => state.package.categorySelected);
  const [categoryConfig, setCategoryConfig] = useState(null);

  useEffect(() => {
    if (categoryId) {
      if (categoryIdPackage) {
        setCategoryConfig(CATEGORIES[CATEGORY[categoryIdPackage]]);
      } else {
        setCategoryConfig(CATEGORIES[CATEGORY[categoryId]]);
      }
    }
  }, [categoryIdPackage, categoryId]);

  return (
    <React.Fragment>
      <HeaderFeature
        breadCrumb
        positionOf={args && args.step && [args.step, 4]}
        titleBreadCrumb={args && args.title}
        announcementAvailable={args && args.announcementAvailable} />
      {<StepContainer
        announcementAvailable={args && args.announcementAvailable}
        alias={categoryConfig && categoryConfig.alias}
      >
        <Component />
      </StepContainer>}
    </React.Fragment>
  )
};

export const withStep = hoc;
